var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCirclePhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 20.733V22.69C24.0003 22.8717 23.963 23.0515 23.8901 23.218C23.8172 23.3845 23.7102 23.5339 23.5761 23.6567C23.442 23.7795 23.2836 23.873 23.1111 23.9312C22.9387 23.9894 22.756 24.0111 22.5747 23.9947C20.5633 23.7766 18.6313 23.0907 16.9338 21.992C15.3545 20.9905 14.0155 19.6541 13.012 18.078C11.9073 16.3761 11.2199 14.4386 11.0053 12.4222C10.989 12.2418 11.0105 12.06 11.0684 11.8883C11.1263 11.7167 11.2194 11.5589 11.3418 11.4251C11.4641 11.2914 11.6131 11.1845 11.7791 11.1113C11.9451 11.0381 12.1246 11.0002 12.306 11.0001H14.267C14.5842 10.9969 14.8917 11.1091 15.1322 11.3155C15.3727 11.5219 15.5298 11.8086 15.5742 12.1221C15.657 12.7484 15.8105 13.3633 16.0318 13.9552C16.1197 14.1887 16.1387 14.4424 16.0866 14.6864C16.0345 14.9303 15.9134 15.1542 15.7376 15.3316L14.9075 16.1601C15.838 17.7933 17.1929 19.1455 18.8293 20.0741L19.6595 19.2457C19.8372 19.0703 20.0615 18.9494 20.306 18.8974C20.5504 18.8453 20.8047 18.8643 21.0386 18.9521C21.6317 19.173 22.2478 19.3261 22.8753 19.4087C23.1929 19.4534 23.4828 19.6131 23.6901 19.8572C23.8974 20.1014 24.0076 20.4131 23.9996 20.733Z",
    stroke: "#070762",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    stroke: "#070762"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePhone);
export default __webpack_public_path__ + "static/media/circle-phone.551ccae2808f478618bceb7e1fc30a4a.svg";
export { ForwardRef as ReactComponent };